import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "2010", value: 2 },
  { name: "2011", value: 5 },
  { name: "2012", value: 6.5 },
  { name: "2013", value: 9 },
  { name: "2014", value: 12.5 },
  { name: "2015", value: 15.5 },
  { name: "2016", value: 18 },
  { name: "2017", value: 26 },
  { name: "2018", value: 33 },
  { name: "2019", value: 41 },
  { name: "2020", value: 64.2 },
  { name: "2021", value: 79 },
  { name: "2022", value: 97 },
  { name: "2023", value: 120 },
  { name: "2024", value: 147 },
  { name: "2025", value: 181 },
];

const renderCustomTooltip = ({ payload }) => {
  if (payload && payload.length > 0) {
    const dataPoint = payload[0].payload;
    return (
      <div className="custom-tooltip">
        <p>{dataPoint.name}</p>
        <p
          style={{ color: "rgb(53, 162, 235)" }}
        >{`Data volume in zetabytes: ${dataPoint.value}`}</p>
      </div>
    );
  }
  return null;
};

const GlobalDataChartRe = () => {
  return (
    <div>
      <p style={{ textAlign: "center", marginBottom: "5px", fontSize: "14px", paddingLeft: "45px" }}>
        Global Data Created<sup style={{ fontSize: "10px" }}>2</sup>
      </p>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip content={renderCustomTooltip} />
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill="rgb(53, 162, 235)"
            animationBegin={500}
            animationDuration={1000}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GlobalDataChartRe;
